import { Navigate, RouteObject } from 'react-router-dom';
import UserFeaturesGuard from '~/guards/UserFeaturesGuard';
import UserRolesGuard from '~/guards/UserRolesGuard';
import { RouteConfig } from '~/routes/routeConfig';
import { FeatureFlag, UserRole } from '~/types/company';
import lazyImport from '~/utils/lazyImport';

const TeamPage = lazyImport(() => import('~/views/settings/Team/Team'));
const UserManagementPage = lazyImport(() => import('~/views/settings/Team/UserManagementView/UserManagementView'));
const ApiKeyPage = lazyImport(() => import('~/views/settings/ApiKey/ApiKey'));
const FeqCredentialPage = lazyImport(() => import('~/views/settings/FeqCredential/FeqCredential'));
const SecurityPage = lazyImport(() => import('~/views/settings/Security/Security'));

export const settingsRoutes: RouteObject[] = [
  {
    path: 'security',
    element: <SecurityPage />,
  },
  // Legacy paths, kept so old links keep resolving to the merged security page.
  {
    path: 'passkey',
    element: <Navigate to={RouteConfig.SettingsSecurity.buildLink()} replace />,
  },
  {
    path: 'mfa',
    element: <Navigate to={RouteConfig.SettingsSecurity.buildLink()} replace />,
  },
  {
    path: 'team/user/new',
    element: <UserManagementPage />,
  },
  {
    path: 'team/user/:companyUserId',
    element: <UserManagementPage />,
  },
  {
    path: 'team',
    element: <TeamPage />,
  },
  {
    path: 'api-key',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.IntegrationApi]}>
        <ApiKeyPage />
      </UserFeaturesGuard>
    ),
  },
  {
    path: 'feq-credential',
    element: (
      <UserRolesGuard
        allowedRoles={[UserRole.ENTREPRENEUR, UserRole.ADVISOR]}
        redirectTo={RouteConfig.SettingsTeam.buildLink()}
      >
        <FeqCredentialPage />
      </UserRolesGuard>
    ),
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Settings.buildLinkWithChildPath('team')} replace />,
  },
];
